module.exports = __webpack_public_path__ + "img/ceb.ba804bba.svg";